import { SETUP_RULE_FIELDS, parseSetupRuleContent } from "./ruleSections";

export interface PublishedRuleSection {
  key: string;
  label: string;
  value: string;
}

/** Lo que el jugador ve del reglamento: SOLO lo que el admin publicó
 * (Eduardo 2026-08-22 — nada generado por formato; el "machote de escalera"
 * aparecía en torneos Round Robin). Contenido con el esquema de secciones
 * → secciones rotuladas; texto libre → se muestra completo como fallback. */
export function splitPublishedRule(content: string | null | undefined): {
  sections: PublishedRuleSection[];
  fallback: string | null;
} {
  const raw = (content ?? "").trim();
  // Texto libre (sin encabezados "## Sección"): el parser lo vuelca entero
  // en "aclaraciones"; aquí se muestra como reglamento adicional completo.
  const hasSchema = SETUP_RULE_FIELDS.some((field) => raw.includes(`## ${field.label}`));
  if (!hasSchema) {
    return { sections: [], fallback: raw || null };
  }
  const parsed = parseSetupRuleContent(raw);
  const sections = SETUP_RULE_FIELDS
    .map((field) => ({ key: field.key, label: field.label, value: parsed[field.key].trim() }))
    .filter((section) => section.value);
  return { sections, fallback: sections.length === 0 && raw ? raw : null };
}

export interface RuleTextBlock {
  /** null = texto sin encabezado «## …» (va como un solo bloque). */
  title: string | null;
  body: string;
}

/** Texto del reglamento en secciones plegables (maqueta 2026-10-06): quita
 * el título «# …» del principio y parte en cada «## Encabezado». Lo que va
 * antes del primer «##» queda como bloque sin título. Sin «##», un solo
 * bloque. Solo texto: quien lo pinta no interpreta HTML. */
export function splitRuleTextBlocks(content: string | null | undefined): RuleTextBlock[] {
  const lines = (content ?? "").replace(/\r\n?/g, "\n").split("\n");
  const firstText = lines.findIndex((line) => line.trim() !== "");
  if (firstText >= 0 && /^#\s+/.test(lines[firstText].trim())) lines.splice(firstText, 1);
  const blocks: RuleTextBlock[] = [];
  let title: string | null = null;
  let body: string[] = [];
  const flush = () => {
    const text = body.join("\n").trim();
    if (title !== null || text) blocks.push({ title, body: text });
  };
  for (const line of lines) {
    const heading = /^##\s+(.+?)\s*#*\s*$/.exec(line.trim());
    if (heading && !line.trim().startsWith("###")) {
      flush();
      title = heading[1].trim();
      body = [];
    } else {
      body.push(line);
    }
  }
  flush();
  return blocks;
}
